import { Pipe, PipeTransform, inject } from '@angular/core';
import {format, formatDistanceToNow, isToday, isTomorrow, isYesterday} from 'date-fns';
import {de, enUS, fr} from 'date-fns/locale';
import type {Locale} from 'date-fns';
import {LocaleService} from '../../translation/services/locale.service';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'relativeDate',
  pure: false
})
export class RelativeDatePipe implements PipeTransform {
  private localeService = inject(LocaleService);
  private translateService = inject(TranslateService);


  private readonly _localeMap: Record<string, Locale> = {
    de,
    en: enUS,
    fr,
  };

  private getLocale(): Locale {
    const userLang = this.localeService.userLanguage;
    return this._localeMap[userLang] ?? de;
  }

  transform(value: Date | string | number | undefined, mode: 'relative' | 'day' = 'relative'): string {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    if (mode === 'day') {
      if (isToday(date)) return this.translateService.instant('relativeDate.today');
      if (isTomorrow(date)) return this.translateService.instant('relativeDate.tomorrow');
      if (isYesterday(date)) return this.translateService.instant('relativeDate.yesterday');
      return format(date, 'EEEE', { locale: this.getLocale() });
    }

    return formatDistanceToNow(date, { addSuffix: true, locale: this.getLocale() });
  }

}
